// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?id=" + {"521":"96c40ad95cceebdb","738":"2f92aba6a9e14bc5","955":"4ee7c581f74b8d59"}[chunkId] + "";
};